import { useCallback, useEffect } from 'react'
import { doc } from 'firebase/firestore'
import {
  type DocumentListenerCallback,
  firestoreListenersManager,
} from '@/shared/lib/firestore-listeners-manager'
import { db } from '../../firebase.js'
import { useAtomValue } from 'jotai'
import { rundownAtom } from '../../store/rundown.store.js'
import { PROMPTER_COLLECTION } from '@rundown-studio/consts'
import { createPrompter } from '../../firestore.js'

export const usePrompterListener = (callback: DocumentListenerCallback) => {
  const rundown = useAtomValue(rundownAtom)
  const rundownId = rundown?.id
  const prompterId = rundown?.prompterId

  const handleCreatePrompter = useCallback(async () => {
    await createPrompter(rundownId)
  }, [rundownId])

  useEffect(() => {
    if (!rundownId) return
    if (!prompterId) {
      handleCreatePrompter()
      return
    }

    const docRef = doc(db, PROMPTER_COLLECTION, prompterId)

    const unsubscribe = firestoreListenersManager.subscribeToDocument(
      docRef,
      callback,
    )

    return () => unsubscribe()
  }, [callback, handleCreatePrompter, prompterId, rundownId])
}
